exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contract-date[data-v-4d6cfb7a] {\n  font-size: 1.265rem;\n  color: rgba(6, 38, 62, 0.65);\n  margin-top: -4px;\n}\n", ""]);

// exports
